import logo from "../assets/images/home-eight/bpayLogoVar2.png";


const SiteLogo = () => {
  return (
    <a href="#home" className="flex items-end gap-1">
      <div className="relative h-max w-[100px] pb-.5">
        <img
          src={logo}
          alt="logo"
          className="object-contain"
        />
      </div>
      <span
        className={`text-blue-sass font-bold text-4xl -ml-1`}
      >
        Pay
      </span>
    </a>
  );
};

export default SiteLogo;
